import React, { Fragment, useEffect, useState } from 'react';
import { useContext } from 'react';
import { CartContext } from '../../Context/CartContext.js';
import { useNavigate } from 'react-router-dom';
import cart2 from '../../Assets/images/cart_2.jpg';
import cart3 from '../../Assets/images/cart_3.jpg';
import cart4 from '../../Assets/images/cart_4.jpg';
import style from "./cart.module.css"
import axios from 'axios';
import { toast } from 'react-toastify';
import { UserContext } from '../../Context/UserContext.js';
import Swal from 'sweetalert2';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';

export default function Cart() {

   const [search, setSearch] = useState([]);
   const { cart, addTest, removeTest, clearCart, getLoggedCart } = useContext(CartContext);
   const { loggedUser } = useContext(UserContext);
   const navigate = useNavigate();



   //& Search Test By Test Name :
   function searchInput(e) {
      if (e.target.value === "") {
         setSearch([])
      }
      if (e.target.value.length >= 3) {
         getSearchData((e.target.value).toLowerCase())
      }
   }


   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      let response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`)
         .catch((error) => {
            toast.warn(error.response.data.message + " Or Not Found", {
               position: "top-right"
            });
         })
      if (response?.data.message === "success") {
         setSearch(response?.data.tests)
      }
   }


   function handleAddTestCart(test) {
      addTest(test, cart?.company?._id);
      setSearch([])
   }


   function handleCompleteInformationUser() {
      if (!loggedUser.phone || !loggedUser.age || !loggedUser.birthDay) {
         Swal.fire({
            title: "تكملة بياناتك الشخصية ",
            text: "! يرجى تكملة بياناتك الشخصية اولا قبل طلب حجز الخدمات ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "الانتقال لتكملة بياناتك الشخصية"
         }).then((result) => {
            if (result.isConfirmed) {
               return navigate("/CompleteProfile?order=true");
            }
         });
      } else {
         return navigate("/order");
      }
   }


   useEffect(() => {
      getLoggedCart();
   }, [])

   return (
      <Fragment>
         <CustomTitle title="سلة التسوق" />
         {cart.profilePrice === undefined ?
            <div className="container cart-container bg-body-tertiary rounded-4 p-2 mb-5">
               <h1 className='main-header'>Cart</h1>
               <div className='under-header'></div>
               {cart && cart.length === 0 ? <div className='text-danger w-75 p-1 m-auto text-center'>لا يوجد تحاليل  لعرضها</div> : <>

                  <div className="row border border-4 border-white m-2">
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart2} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart3} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart4} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                  </div>


                  <div className="row p-2 gap-2">
                     <h3>Company: {cart?.company?.name}</h3>
                     {cart?.cartItems?.map((ele) =>
                        <div key={ele._id} className={`${style.testName} col-12 bg-light-subtle py-1 px-4 rounded-3 border border-1 `}>
                           <div className='d-flex justify-content-between align-item-center '>
                              <p className={`p-0 m-0`} >{ele.test?.name}</p>
                              <div className=''>
                                 <p className={`p-0 m-0`} dir='rtl'>
                                    <span className='main-color fw-bold'>{isNaN(Math.round(ele.price?.priceAfterDiscount)) ? "0" : Math.round(ele.price?.priceAfterDiscount)}  </span>
                                    <span className='mx-2'>بدلا من </span>
                                    <span className='text-danger fw-bold'>{isNaN(Math.round(ele.price?.price)) ? "0" : Math.round(ele.price?.price)}</span>
                                 </p>
                              </div>
                              <i onClick={() => { removeTest(ele.test?._id) }} className={`fa-solid fa-trash text-danger btn`} title="Remove Test From Cart"></i>
                              {/* <i class="fa-solid fa-circle-xmark text-danger btn"></i> */}
                           </div>

                           <div>
                              <details className='text-center'>
                                 <summary className={`btn m-0 p-0`}>شروط التحليل</summary>
                                 <p>{ele.test?.condition}</p>
                              </details>
                           </div>
                        </div>
                     )}




                     <hr className='main-color my-4 w-75 m-auto' />
                     <div className="col-md-8 offset-md-2">
                        <form >
                           <div className='position-relative'>
                              <i className={`${style.icon_search} fa-solid fa-microscope icon_search`}></i>
                              <input type="search" onChange={(e) => { searchInput(e) }} className='form-control py-4' id='test_search' placeholder='أضافة تحاليل أخرى' name="search" />
                           </div>
                        </form>

                        {search.length ?
                           <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                              {search.map((ele) => <p key={ele._id} onClick={() => { handleAddTestCart(ele._id) }} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 main-color cursor'>{ele.name}</p>)}
                           </div>
                           : ""
                        }
                     </div>
                     <hr className='main-color my-4 w-75 m-auto' />

                     <div className="d-flex justify-content-center align-items-center">
                        <div className=''>
                           <p className="m-0 " dir='rtl'>
                              <span className='ms-2 fw-bold'>أجمالى القيمة النهائية    :  </span>
                              <span className='fs-4 main-color fw-bold'>{isNaN(Math.round(cart?.total_After_Discount)) ? "0" : Math.round(cart?.total_After_Discount)}</span>
                              <span className='mx-2'>بدلا من </span>
                              <span className='fs-4 text-danger fw-bold'>{isNaN(Math.round(cart?.total_Price)) ? "0" : Math.round(cart?.total_Price)}</span>
                           </p>
                           <p className='h6 m-0 fw-bold text-center'>أجمالى عدد التحاليل  : {isNaN(cart?.cartItems?.length) ? "0" : cart?.cartItems?.length}</p>
                        </div>
                     </div>

                  </div>

                  <div>
                     <button onClick={() => { handleCompleteInformationUser() }} className='btn bg-main d-block m-auto w-75'>أحجز الأن</button>
                  </div>

               </>}

               {cart.length === 0 ?
                  ""
                  :
                  <div className='d-flex justify-content-evenly align-items-center w-75 m-auto mt-3 mb-5'>
                     <button onClick={() => { clearCart() }} className='btn btn-outline-danger btn-sm d-block w-50 me-2'>افراغ السلة</button>
                  </div>
               }

               {/* <div className='d-flex justify-content-evenly align-items-center w-75 m-auto mt-3 mb-5'>
                     <button onClick={()=>{clearCart()}} className='btn btn-outline-danger btn-sm d-block w-50 me-2'>افراغ السلة</button>
                  </div> */}

            </div>
            :
            <div className="container cart-container bg-body-tertiary rounded-4 p-2 mb-5">
               <h1 className='main-header'>Cart</h1>
               <div className='under-header'></div>
               {cart && cart.length === 0 ? <div className='text-danger w-75 p-1 m-auto text-center'>لا يوجد تحاليل  لعرضها</div> : <>

                  <div className="row border border-4 border-white m-2">
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart2} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart3} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                     <div className="col-4 p-0">
                        <div className='border border-5 border-white text-center'>
                           <img src={cart4} className="img-fluid" alt="cartImage"></img>
                        </div>
                     </div>
                  </div>


                  <div className="row p-2 gap-2">
                     <h3>Company: {cart?.company?.name}</h3>
                     <div className="d-flex justify-content-center align-items-center">
                        <div className=''>
                           <p className="m-0 " dir='rtl'>
                              <span className='ms-2 fw-bold'>أجمالى القيمة النهائية    :  </span>
                              <span className='fs-4 main-color fw-bold'>{cart?.profilePrice}</span>
                              <span className='mx-2'>بدلا من </span>
                              <span className='fs-4 text-danger fw-bold'>{cart?.total_Price}</span>
                           </p>
                           <p className='h6 m-0 fw-bold text-center'>أجمالى عدد التحاليل  : {isNaN(cart?.cartItems?.length) ? "0" : cart?.cartItems?.length}</p>
                        </div>
                     </div>

                  </div>


               </>}

               <div>
                  <button onClick={() => { handleCompleteInformationUser() }} className='btn bg-main d-block m-auto w-75'>أحجز الأن</button>
               </div>

               {cart.length === 0 ?
                  ""
                  :
                  <div className='d-flex justify-content-evenly align-items-center w-75 m-auto mt-3 mb-5'>
                     <button onClick={() => { clearCart() }} className='btn btn-outline-danger btn-sm d-block w-50 me-2'>افراغ السلة</button>
                  </div>
               }
            </div>
         }
      </Fragment>
   )
}
